import { render, staticRenderFns } from "./SettingsInputText.vue?vue&type=template&id=2f52ab70&scoped=true"
import script from "./SettingsInputText.vue?vue&type=script&lang=js"
export * from "./SettingsInputText.vue?vue&type=script&lang=js"
import style0 from "./SettingsInputText.vue?vue&type=style&index=0&id=2f52ab70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52ab70",
  null
  
)

export default component.exports